import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { withEventReplay } from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from './shared/interceptor/auth.interceptor';
import { IconDefinition } from '@ant-design/icons-angular';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { provideNzI18n, en_US } from 'ng-zorro-antd/i18n';
import { provideNativeDateAdapter } from '@angular/material/core';
import { EposRouteReuseStrategy } from './shared/route-reuse/epos-route-reuse.strategy';

const antDesignIcons = AllIcons as Record<string, IconDefinition>;
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key],
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: EposRouteReuseStrategy },
    // provideHttpClient(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideNzIcons(icons),
    provideAnimations(),
    provideNzI18n(en_US),
    provideNativeDateAdapter(),
  ],
};
